import { Directive, ElementRef, HostListener } from '@angular/core';

// Estimación del tamaño del lente de zoom — debe mantenerse en sync con
// --red-zoom-thumb-w/h y --red-zoom-min-scale-factor en styles.scss
// (.red-zoom--style--window .red-zoom__lens)
const LENS_WIDTH = 330; // 220px * 1.5
const LENS_HEIGHT = 390; // 260px * 1.5
const MOBILE_BREAKPOINT = 850;
const VIEWPORT_MARGIN = 8;

@Directive({
  selector: '[appRedZoomFlip]'
})
export class RedZoomFlipDirective {
  constructor(private readonly elementRef: ElementRef<HTMLElement>) { }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const rect = this.elementRef.nativeElement.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const gap = vw <= MOBILE_BREAKPOINT ? 8 : 16;

    const spaceRight = vw - rect.right;
    const spaceLeft = rect.left;
    const spaceBelow = vh - rect.bottom;
    const spaceAbove = rect.top;

    const clampX = (x: number) => Math.max(
      VIEWPORT_MARGIN,
      Math.min(x, vw - LENS_WIDTH - VIEWPORT_MARGIN),
    );

    let x: number;
    let y: number;

    if (spaceRight >= LENS_WIDTH + gap) {
      x = rect.right + gap;
      y = rect.top + 4;
    } else if (spaceLeft >= LENS_WIDTH + gap) {
      x = rect.left - LENS_WIDTH - gap;
      y = rect.top + 4;
    } else if (spaceBelow >= LENS_HEIGHT + gap) {
      x = clampX(rect.left);
      y = rect.bottom + gap;
    } else if (spaceAbove >= LENS_HEIGHT + gap) {
      x = clampX(rect.left);
      y = rect.top - LENS_HEIGHT - gap;
    } else {
      x = (vw - LENS_WIDTH) / 2;
      y = (vh - LENS_HEIGHT) / 2;
    }

    const root = document.documentElement.style;
    root.setProperty('--red-zoom-window-x', `${Math.round(x + window.scrollX)}px`);
    root.setProperty('--red-zoom-window-y', `${Math.round(y + window.scrollY)}px`);
  }
}
